import * as firebase from 'firebase'

import 'firebase/storage';
import 'firebase/firestore';
import 'firebase/auth'

// const firebaseConfig = {
//     apiKey: "AIzaSyDGmVBx5LAYJuIq_Ni1nZBenfcVUFX-SyY",
//     authDomain: "ecommerce-with-react-2ac06.firebaseapp.com",
//     databaseURL: "https://ecommerce-with-react-2ac06.firebaseio.com",
//     projectId: "ecommerce-with-react-2ac06",
//     storageBucket: "ecommerce-with-react-2ac06.appspot.com",
//     messagingSenderId: "690603499200",
//     appId: "1:690603499200:web:09860bc318b5b7fd74d725",
//     measurementId: "G-88N35MC51Q"
// }; 

const firebaseConfig = { 
    apiKey: "AIzaSyB_LyphZYlK8CHPFtIeQBrzKutFH-Ua7rI",
    authDomain: "fashion-design-ff1d2.firebaseapp.com",
    projectId: "fashion-design-ff1d2",
    storageBucket: "fashion-design-ff1d2.appspot.com",
    messagingSenderId: "1019359486244",
    appId: "1:1019359486244:web:b2b830deff4a185f9113b1",
    measurementId: "G-0F37X7SCNZ"
}

firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export { auth, db, storage }